<template>
  <div class="relative"></div>
  <div class="h-80 bg-bgheader absolute w-full"></div>
  <div class="absolute w-full">
    <div class="flex flex-col justify-center">
      <h2 class="text-right text-base font-bold pt-10 mr-5 text-white">
        جستجوی مشتری
      </h2>
      <div class="flex flex-row justify-center items-center">
        <input
          class="border text-center p-2 rounded-lg text-cyan-900 bg-white shadow-lg mt-2 w-4/5 ml-1"
          placeholder="جستجو ..."
          v-model="vlaSearch"
          @keyup.enter="search"
        />

        <div
          class="flex justify-center py-1.5 px-2 mt-2 bg-bgbutton border border-yellow-500 rounded-xl shadow-md"
          @click="search(1)"
        >
          <font-awesome-icon
            icon="magnifying-glass"
            class="fa-xl text-bgfont mt-1"
          />
        </div>
      </div>
    </div>
    <div
      v-if="resultSearch <= 0"
      class="mt-5 mx-5 h-36 flex items-center justify-center rounded-2xl border bg-white px-4 text-center text-lg text-cyan-900 shadow-lg"
    >
      <span class="font-bold text-red-800">
        داده‌ای برای نمایش وجود ندارد
      </span>
    </div>
    <div class="pb-20">
      <div
        v-for="item in arrayResult"
        :key="item.customerId"
        class="bg-white border rounded-xl shadow-md p-2 mx-5 my-2 text-sm text-cyan-900"
      >
        <!-- ردیف ۱: نام و فروشگاه -->
        <div class="grid grid-cols-2 gap-2 mb-2 space-y-1">
          <div class="flex items-center gap-1">
            <font-awesome-icon icon="circle-user" class="text-bgbutton w-4" />
            <span class="font-bold">نام:</span>
            <span class="truncate"
              >{{ item.customerName }} {{ item.customerFamily }}</span
            >
          </div>
          <div class="flex items-center gap-1">
            <font-awesome-icon icon="shop" class="text-bgbutton w-4" />
            <span class="font-bold">فروشگاه:</span>
            <span class="truncate">{{ item.sherkaT_N }}</span>
          </div>
        </div>

        <!-- ردیف ۲: تلفن و همراه -->
        <div class="grid grid-cols-2 gap-2 mb-2 space-y-1">
          <div class="flex items-center gap-1">
            <font-awesome-icon
              icon="square-phone-flip"
              class="text-bgbutton w-4"
            />
            <span class="font-bold">تلفن:</span>
            <span>
              <template v-if="item.tel1 && item.tel2"
                >{{ item.tel1 }} / {{ item.tel2 }}</template
              >
              <template v-else>{{ item.tel1 || item.tel2 || "-" }}</template>
            </span>
          </div>
          <div class="flex items-center gap-1">
            <font-awesome-icon
              icon="mobile-screen-button"
              class="text-bgbutton w-4"
            />
            <span class="font-bold">همراه:</span>
            <span>{{ item.mobile }}</span>
          </div>
        </div>

        <!-- ردیف ۳: تفصیلی و اعتبار -->
        <div class="grid grid-cols-2 gap-2 mb-2 space-y-1">
          <div class="flex items-center gap-1">
            <font-awesome-icon icon="id-badge" class="text-bgbutton w-4" />
            <span class="font-bold">تفصیلی:</span>
            <span>{{ item.customerId }}</span>
          </div>
          <div class="flex items-center gap-1">
            <font-awesome-icon
              icon="money-check-dollar"
              class="text-bgbutton w-4"
            />
            <span class="font-bold">اعتبار:</span>
            <span>{{ item.mandeEtebar }}</span>
          </div>
        </div>

        <!-- ردیف ۴: آدرس -->
        <div class="flex items-center gap-1 mb-3 space-y-1">
          <font-awesome-icon icon="location-dot" class="text-bgbutton w-4" />
          <span class="font-bold">آدرس:</span>
          <span class="truncate">{{ item.address }}</span>
        </div>

        <!-- دکمه -->
        <div class="flex justify-center items-center space-y-1">
          <button
            class="w-full bg-bgbutton hover:bg-yellow-500 py-2 mx-20 rounded-lg text-cyan-900 font-medium shadow-sm transition"
            :disabled="loading"
            @click="redirectToProduct(item.customerId)"
          >
            ادامه
          </button>
        </div>
      </div>

      <v-pagination
        v-if="resultSearch > 0 && pagination && pagination.totalPages"
        v-model="pagination.pageNumber"
        :pages="pagination.totalPages"
        :range-size="1"
        active-color=""
        @update:modelValue="search"
      />
    </div>
  </div>
</template>
<script>
import { searchCustomer } from "../API/API";
import VPagination from "@hennge/vue3-pagination";
import "../assets/css/pagination.css";
import { debounce } from "lodash";
export default {
  name: "CustomerPage",
  components: { VPagination },
  data() {
    return {
      result: [],
      arrayResult: [],
      resultSearch: null,
      pagination: {},
    };
  },
  mounted() {},
  created() {
    this.debouncedSearch = debounce(this.search, 500);
  },
  methods: {
    async search(pageNumber) {
      if (!this.vlaSearch.trim()) return;
      this.$store.dispatch("cart/emptyCart");
      try {
        localStorage.removeItem("selectedCustomer");
        localStorage.removeItem("selectedAddress");
        localStorage.removeItem("selectedAddressId");
        this.result = await searchCustomer(this.vlaSearch, pageNumber);
        this.resultSearch = this.result.data.result.data.length;
        this.arrayResult = this.result.data.result.data;
        this.pagination = {};
        this.pagination = this.result.data.result.pagination;
        this.$store.commit("cart/SET_SEARCH_RESULT", this.arrayResult);
      } catch (error) {
        this.inputCodeMelli.error = "خطا در ارتباط با سرور.";
      }
    },
    redirectToProduct(id) {
      localStorage.setItem("selectedCustomer", id);
      localStorage.setItem("selectedAnbar", 1);
      let customer = localStorage.getItem("selectedCustomer");
      const SearchResults = this.$store.getters["cart/getCustomerById"](id);
      localStorage.setItem(
        "SearchResults",
        JSON.stringify(SearchResults.isMaxPackageControl)
      );
      this.$router.push(`address/${customer}`);
    },
    getReport(id) {
      console.log(id);
      this.$router.push(`customer/${id}`);
    },
  },
  computed: {
    cartCount() {
      return this.$store.state.cart.products.length;
    },
  },
  watch: {
    vlaSearch() {
      this.debouncedSearch();
    },
  },
};
</script>
